import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../shared/core/state';
import { selectIsLoggedIn } from '../../../shared/core/state/users/user.selectors';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'black-teach-hero-section',
  templateUrl: './teach-hero-section.component.html',
  styleUrls: ['./teach-hero-section.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class TeachHeroSectionComponent implements OnInit {
  private store = inject<Store<State>>(Store);
  isUserLoggedIn = false;

  ngOnInit(): void {
    this.store.select(selectIsLoggedIn).subscribe((loggedIn) => {
      this.isUserLoggedIn = loggedIn;
    });
  }
}
